<template>
  <!-- <v-parallax src=""> -->
  <v-row>
    <v-col class="pa-6"
      :style="[
      {'background-image': `url('${require('@/assets/fondo-loginstrategio.jpg')}')`},
      {'background-repeat': 'no-repeat'},
      {'background-size': 'cover'}
      ]"
    >
      <v-container id="login" fluid>
        <v-row class="py-md-4 ma-lg-4" align-content="center">
          <v-col >
            <v-img width="253px" height="auto" :src="require('@/assets/logo-vida-software.png')"></v-img> 
          </v-col>
        </v-row>
        <v-row class="pa-md-8 ma-md-8" style="padding-top: 0px!important;padding-bottom: 0px!important;"></v-row>
        <v-row class="pt--md-16 ma-5">
          <v-col class="py-3">
            <div id="brand-message-title" class="text-sm-left">
              {{brandMessage.title}}
            </div>
            <div id="brand-message-subtitle">
              {{brandMessage.subtitle}}
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-col>
    
    <v-col
    :style="[
      {'background-color': `#FBFBFB`}      
      ]"
    >
      <v-container id="login" fluid>
        <v-col>
          <v-row class="py-md-4 ma-lg-3" align-content="center" style="padding-bottom: 0px!important;">
            <v-col>
              <v-img width="235px" height="auto" :src="require('@/assets/logo-strategio.png')"></v-img>
            </v-col>
          </v-row>
          <v-row align-content="center">
            <v-col>
              <v-form @submit="logIn($event)"> 
                <v-card class="pa-lg-16 mx-lg-16" elevation="0" color="#FBFBFB" style="padding: 6px!important;" v-show="!showInterface"> 
                  <v-row class="hidden-xs-only" >
                    <v-col cols="8" align-self="center" >
                      <v-card-text class="text-h4" style="color:#25235F;-webkit-text-stroke: 0.8px; height: auto; font-size: 11vw; font-weight: bold;">
                      Inicia Sesión
                      </v-card-text>
                    </v-col>
                    <v-col align-self="center" cols="3" offset-lg="1">
                      <v-img  width="83.83px" height="auto" :src="require('@/assets/icono-strategio.png')"></v-img>
                    </v-col>
                   </v-row>
                        
                   <v-card-text >
                    <div>                          
                      <v-card-text :contain="true" style="color:#25235F;font-size:16px;font-weight:700"> Usuario
                      </v-card-text>                       
                      <v-text-field class="pa-xs-0 txtUser"
                        id="txtUser"
                        name="txtUser"
                       
                        prepend-inner-icon="person_outline"
                        outlined
                        background-color="#FFFFFF"
                        style="margin-bottom: -20px;"
                      ></v-text-field>                          
                    </div>
                    <div>                          
                      <v-card-text :contain="true" style="color:#25235F;font-size:16px;font-weight:700"> Contraseña
                      </v-card-text>                          
                      <v-text-field 
                        id="txtPassword"
                        name="txtPassword"
              
                        prepend-inner-icon="lock_outline"
                        :style="[{'font-family': 'Open Sans'}, {'font-weight': '700'}, {'color': 'rgba(0, 0, 0, 0.3)'}]"
                        :append-icon="hidePassword ? 'visibility' : 'visibility_off'"
                        :type="hidePassword ? 'password' : 'text'"
                        @click:append="hidePassword = !hidePassword"
                        outlined
                        background-color="#FFFFFF"
                      ></v-text-field>
                    </div>
                    <div class="strategio-login-error-message">
                      {{errorMessage}}
                    </div>
                    <div >
                      <a v-on:click="showNewInterface">Olvidaste tu contraseña?</a>
                    </div>
                    <div style="text-align: center;">
                      <v-btn
                        style="background-color:#23A2D9;color:white;font-size:14px;width:150px"
                        large rounded depressed
                        class="mx-0"
                        type="submit"
                        :loading="isLoading"
                        @click.native="loader = 'loading'"
                        :disabled="isLoading"
                      >
                        Ingresar
                      </v-btn>
                    </div>
                 
                  </v-card-text>
          </v-card>
          <v-card class="pa-lg-16 mx-lg-16" elevation="0" color="#FBFBFB" style="padding: 6px!important;" v-show="showInterface">  
                   <v-row class="hidden-xs-only" >
                    <v-col cols="8" align-self="center" >
                      <v-card-text class="text-h4" style="color:#25235F;-webkit-text-stroke: 0.8px; height: auto; font-size: 24px!important; font-weight: bold;">
                      Recuperar Contraseña
                      </v-card-text>
                    </v-col>
                    <v-col align-self="center" cols="3" offset-lg="1">
                      <v-img  width="83.83px" height="auto" :src="require('@/assets/icono-strategio.png')"></v-img>
                    </v-col>
                   </v-row>
            
                  <v-card-text v-show="!showNew">
                    <div>                          
                      <v-card-text :contain="true" style="color:#25235F;font-size:16px;font-weight:700"> Ingrese correo de recuperación
                      </v-card-text>                       
                      <v-text-field class="pa-xs-0 txtUser"
                        id="txtCorreo"
                        name="txtCorreo"               
                        prepend-inner-icon="person_outline"
                        outlined
                        v-model="newMail"
                        background-color="#FFFFFF"
                        style="margin-bottom: -20px;"
                      ></v-text-field>                          
                    </div>
                    <div class="strategio-login-error-message">
                      {{errorMessage}}
                    </div>
                    <div style="text-align: center;">
                      <v-btn
                        style="background-color:#23A2D9;color:white;font-size:14px;width: 180px;"
                        rounded depressed
                        v-on:click="restaurar_pwd"
                        :loading="isLoading"
                        @click.native="loader = 'loading'"
                        :disabled="newMail === '' || isLoading"
                      >
                        Enviar código
                      </v-btn>
                      <v-btn
                        style="background-color:#23A2D9;color:white;font-size:14px;width: 180px;"
                        rounded depressed
                        class="mx-0"
                        v-on:click="showNewInterface"
                      >
                        Volver  
                      </v-btn>
                    </div>
                  </v-card-text>  

          
                   <v-card-text v-show="showNew">
                    <div>                          
                      <v-card-text :contain="true" style="color:#25235F;font-size:16px;font-weight:700"> Código
                      </v-card-text>                       
                      <v-text-field class="pa-xs-0 txtUser"
                        id="txtCodigo"
                        name="txtCodigo"
                        label="Escribe el código que enviamos a tu correo"
                        prepend-inner-icon="person_outline"
                        outlined
                        background-color="#FFFFFF"
                        style="margin-bottom: -20px;"
                      ></v-text-field>                          
                    </div>
                    <div>                          
                      <v-card-text :contain="true" style="color:#25235F;font-size:16px;font-weight:700"> Contraseña
                      </v-card-text>                          
                      <v-text-field 
                        id="txtNewPassword"
                        name="txtNewPassword"
                        label="Escribe tu nueva contraseña"
                        prepend-inner-icon="lock_outline"
                        :style="[{'font-family': 'Open Sans'}, {'font-weight': '700'}, {'color': 'rgba(0, 0, 0, 0.3)'}]"
                        :append-icon="hidePassword ? 'visibility' : 'visibility_off'"
                        :type="hidePassword ? 'password' : 'text'"
                        v-model="newPassword"
                        @click:append="hidePassword = !hidePassword"
                        
                        :rules="[(v) => v && v.length > 5 || 'Minimo 6 characters']"
                        :min="6"
                        single-line
                        background-color="#FFFFFF"
                      ></v-text-field>
                    </div>
                    <div>                          
                      <v-card-text :contain="true" style="color:#25235F;font-size:16px;font-weight:700"> Confirmar Contraseña
                      </v-card-text>                          
                      <v-text-field 
                        id="txtConfirmPassword"
                        name="txtConfirmPassword"
                        label="Confirma la nueva contraseña"
                        prepend-inner-icon="lock_outline"
                        :style="[{'font-family': 'Open Sans'}, {'font-weight': '700'}, {'color': 'rgba(0, 0, 0, 0.3)'}]"
                        :rules="[validatePassword()]"
                        :append-icon="hidePassword ? 'visibility' : 'visibility_off'"
                        :type="hidePassword ? 'password' : 'text'"
                        v-model="confirmPassword"
                        @click:append="hidePassword = !hidePassword"
                        
                        single-line
                        background-color="#FFFFFF"
                      ></v-text-field>
                    </div>
                    <div class="strategio-login-error-message">
                      {{errorMessage}}
                    </div>
                    <div style="text-align: center;">
                      <v-btn
                        style="background-color:#23A2D9;color:white;font-size:14px;width: 150px;"
                        rounded depressed
                        :disabled="!canChangePassword || newPassword === ''"
                        v-on:click="cambiar_pwd"
                        
                      >
                       Guardar
                      </v-btn>
                      <v-btn
                        style="background-color:#23A2D9;color:white;font-size:14px;width: 150px;"
                        rounded depressed
                        class="mx-0"
                        v-on:click="showNewInterface2"
                      >
                        Volver  
                      </v-btn>
                    </div>
                  </v-card-text>
                </v-card>
              </v-form>
            </v-col>
          </v-row>
          <v-row class="pa-md-8 ma-md-8"></v-row>
          <v-row class="pa-md-8 ma-md-8"></v-row>
        </v-col>
      </v-container>

      <v-footer
        class="px-4 mb-2 text-right"
        color="transparent"
        style="font-size:10px;color:black;"
      >
        <v-col>
          © TODOS LOS DERECHOS RESERVADOS - VIDA SOFTWARE
        </v-col>
      </v-footer>
    </v-col>
  </v-row>

</template>

<script>
import auth from '../utils/auth'
import storageCleaner from '../utils/storageCleaner'

export default {
  name: 'login',
  data () {
    delete localStorage.token
    delete localStorage.user
    storageCleaner.cleanStorage()
    return {
      msg: 'Welcome to Your Vue.js App',
      hidePassword: true,
      errorMessage: '',
      isLoading: false,
      brandMessage: {
        title: 'Y tú ¿Cuánto vendiste ayer?',
        subtitle: 'Analiza lo mejor. Todo es realidad con nosotros'
      },
      showNew: true,
      newPassword: '',
      newMail: '',
      confirmPassword: '',
      canChangePassword: false,
      showInterface: false
    }
  },
  methods: {
    logIn (e) {
      e.preventDefault()
      this.errorMessage = ''
      this.isLoading = true

      const user = document.getElementById('txtUser').value
      const password = document.getElementById('txtPassword').value
      auth.login({
        context: this,
        creds: {user, password},
        onSuccess: (response) => {
          this.isLoading = false
          // console.log(response.data.user)
          if (response.data.user.forceChangePassword === 1) {
            response.data.status = '1'
            response.data.message = 'OK'
            this.$router.push({ name: 'UserAccount', params: { showStrategioAppBar: false } })
          } else {
            if (response.data.user.userType === 'SUPERVISOR') {
              // this.$router.push('/supervise/dashboard')
              this.$router.push({
                name: 'MainPage',
                params: { folderID: '0', firstTimeMenu: true }
              })
            } else {
              // this.$router.push('/0')
              this.$router.push({
                name: 'MainPage',
                params: { folderID: '0', firstTimeMenu: true }
              })
            }
          }
        },
        onError: (error) => {
          this.isLoading = false
          let errMessage = 'Error desconocido'
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            // console.log(error.response.data)
            errMessage = error.response.data.message
            // console.log(error.response.status);
            // console.log(error.response.headers);
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            // console.log(error.request)
            errMessage = 'No pudimos obtener respuesta del servidor'
          } else {
            // Something happened in setting up the request that triggered an Error
            errMessage = `Error desconocido: ${error.errorMessage}`
          }
          this.errorMessage = errMessage
          // console.log(error.config)
        }
      })
      return false
    },
    restaurar_pwd (e) {
      e.preventDefault()
      this.errorMessage = ''
      this.isLoading = true

      const mail = document.getElementById('txtCorreo').value
      auth.correo_recuperacion({
        context: this,
        creds: {mail},
        onSuccess: (response) => {
          this.isLoading = false
          // console.log(response.data.status)
          if (response.data.status === '1') {
            this.showNewFilter()
            response.data.status = '1'
            this.errorMessage = response.data.message
          }
        },
        onError: (error) => {
          this.isLoading = false
          let errMessage = 'Error desconocido'
          if (error.response) {
            errMessage = error.response.data.message
          } else if (error.request) {
            errMessage = 'No pudimos obtener respuesta del servidor'
          } else {
            errMessage = `Error desconocido: ${error.errorMessage}`
          }
          this.errorMessage = errMessage
        }
      })
      return false
    },
    validatePassword () {
      this.canChangePassword = (this.newPassword === this.confirmPassword) && this.newPassword.length >= 6
      return this.canChangePassword || 'Los passwords deben ser iguales'
    },
    cambiar_pwd (e) {
      e.preventDefault()
      this.errorMessage = ''
      this.isLoading = false

      const mail = this.newMail
      const customCode = document.getElementById('txtCodigo').value
      const pwd = this.newPassword
      const confirmPwd = this.confirmPassword

      if (pwd !== confirmPwd) {
        this.errorMessage = 'Las contraseñas no coinciden'
      } else {
        this.isLoading = true
        auth.correo_change_pwd({
          context: this,
          creds: {mail, customCode, pwd, confirmPwd},
          onSuccess: (response) => {
            this.isLoading = false
            // console.log(response.data.status)
            if (response.data.status === '1') {
              this.showNewInterface2()
              response.data.status = '1'
              this.errorMessage = 'Contraseña actualizada correctamente'
            }
          },
          onError: (error) => {
            this.isLoading = false
            this.newMail = ''
            this.newPassword = ''
            this.confirmPassword = ''
            let errMessage = 'Error desconocido'
            if (error.response) {
              errMessage = error.response.data.message
            } else if (error.request) {
              errMessage = 'No pudimos obtener respuesta del servidor'
            } else {
              errMessage = `Error desconocido: ${error.errorMessage}`
            }
            this.errorMessage = errMessage
          }
        })
      }

      return false
    },
    showNewFilter () {
      this.showNew = !this.showNew
    },
    showNewInterface () {
      this.showInterface = !this.showInterface
      this.showNew = !this.showNew
    },

    showNewInterface2 () {
      this.showInterface = !this.showInterface
      this.showNew = true
    }
  }
}
</script>
<style>
.strategio-login-error-message {
  text-align: center;
  color: #F44336;
}
._poweredBy {
  margin-top: 16px;
  text-align: right;
  font-weight: 600;
}
#brand-message-title {
  font-size: 4vw;
  font-weight: bold;
  /* text-align: right; */
  color: #55CCFF;
}

#brand-message-subtitle {
  font-size: 2vh;
  font-weight: normal;
  text-align: start;
  color: white;
}

#txtUser {
  font-family: 'Open Sans'; 
  font-weight: 700;
}

.txtConfirmPassword .v-label{
  font-size: 14px!important;
}

.v-card__subtitle, .v-card__text, .v-card__title {
    padding: 6px!important;
    margin-bottom: 0px!important;
}
.v-text-field {
    padding-top: 2px;
    margin-top: 4px;
}

/* Correción para el texto en outline que se va mucho a la izquierda */
.txtUser .v-label.theme--light.error--text {
left: 0 !important;
}
.txtUser .v-label.v-label--active.theme--light {
left: -27px !important;
}

</style>



// WEBPACK FOOTER //
// src/routes/login.vue